import { LocationOnOutlined } from '@mui/icons-material'
import { JSX } from 'react'

const LocationOnOutlinedIcon = (): JSX.Element => <LocationOnOutlined />

export default LocationOnOutlinedIcon
